import client from "@/lib/axios";
import { HydraListResponse, SortOrder } from "@/types";
import { deserializeHydraListResponse } from "@/utils";
import { CreateTeammateSuccessResponse, TeammateResourceRoles, Teammate } from "../../types";

export default {
  list: async (searchValue: string, order: SortOrder | null, page: number = 0) => {
    const response = await client.get<HydraListResponse<Teammate>>("/teammates", {
      params: {
        page,
        email: searchValue || null,
        [`order[email]`]: order,
      },
    });

    return deserializeHydraListResponse(response.data);
  },

  listAll: async () => {
    const response = await client.get<HydraListResponse<Teammate>>("/teammates", {
      params: {
        itemsPerPage: 500,
      },
    });

    return deserializeHydraListResponse(response.data);
  },
  get: async (id: number | undefined) => {
    const response = await client.get<Teammate>(`/teammates/${id}`);

    return response.data;
  },
  create: async (data: Partial<Teammate>) => {
    const response = await client.post<CreateTeammateSuccessResponse>("/teammates", data);

    return response.data;
  },
  assignTeammateRolesToResources: async (id: number, data: TeammateResourceRoles) => {
    const response = await client.post(`/teammates/${id}/website_access`, data);

    return response.data;
  },
  editTeammateRolesToResources: async (id: number, data: TeammateResourceRoles) => {
    const response = await client.put(`/teammates/${id}/website_access`, data);

    return response.data;
  },
  edit: async (id: number, data: Partial<Teammate>) => {
    const response = await client.put<Teammate>(`/teammates/${id}`, data);

    return response.data;
  },
  delete: async (id: number) => {
    await client.delete(`/teammates/${id}`);
  },
};
